import store from '../../utils/redux-store';

import { getDangerouslyUseFeatureFlags } from './featureFlagsReducer';
import { FEATURE_FLAGS_REDUCER_KEY } from './featureFlagsTypes';

const getResourceStore = (state = store.getState()) => state[FEATURE_FLAGS_REDUCER_KEY];
// const getResourceStore = (state: Object) => state[FEATURE_FLAGS_REDUCER_KEY];
export const getFeatureFlags = (state) => getResourceStore(state).featureFlags;
export const getFeatureFlag = (state, key) => getResourceStore(state).featureFlags.get(key);
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getError = (state) => getResourceStore(state).error;

export const getFeatureFlagEnsured = (state, key) =>
  !getLoadPending(state) || !getIsLoading(state) || getError(state) ? getFeatureFlag(state, key) : null;

export const dangerouslyUseFeatureFlags = () => getDangerouslyUseFeatureFlags();
